import { render } from "./BlockImageOverText.vue?vue&type=template&id=75b89722&lang=pug"
import script from "./BlockImageOverText.vue?vue&type=script&lang=js"
export * from "./BlockImageOverText.vue?vue&type=script&lang=js"

import "./BlockImageOverText.vue?vue&type=style&index=0&id=75b89722&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__